import { useEffect } from "react";
import { getImageFile, setImageFile } from "../../../services/storage/MediaStorage";
import { isUserOnline } from "../../../services/storage/LocalStorage";


export const usePreloadCachedImages = () => {
	useEffect(() => {
		if (!isUserOnline()) return;

		const offlineAssets = [
			{ imgKey: "sad-cloud-offline", imgUrl: "/img/sad-cloud.png" },
			{ imgKey: "threeDotsLoader", imgUrl: "/img/Loft_loading.gif" },
			{ imgKey: "chatWidget", imgUrl: "/img/floatingBot.png" },
			{ imgKey: "frontmMainLogo", imgUrl: "/img/logo-main.gif" },
			// Add more assets here
		];

		const preload = async () => {
			for (const { imgKey, imgUrl } of offlineAssets) {
				try {
					const cached = await getImageFile(imgKey);
					if (!(cached instanceof Blob)) {
						const response = await fetch(imgUrl);
						if (!response.ok) {
							console.warn(`[CachedImage] Failed to fetch: ${imgUrl}`);
							continue;
						}
						const blob = await response.blob();
						await setImageFile(imgKey, blob);
					} else {
						// console.log(`[CachedImage] Already cached: ${imgKey}`);
					}
				} catch (err) {
					// console.error(`[CachedImage] Error caching ${imgKey}:`, err);
				}
			}
		};

		preload();
	}, []);
};
